<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {},
  watch: {
    message(newMessage, oldMessage) {
      // 响应数据变化的逻辑
      console.log('Message changed from ' + oldMessage + ' to ' + newMessage);
    },
    myData: {
      handler(newData) {
        // 将数据保存到localStorage
        localStorage.setItem('myData', JSON.stringify(newData));
      },
      deep: true, // 深度监听对象的
    },
    changeMessage() {
      this.message = 'New Message';
    },
  }
}

</script>

<style lang="less">

* {
  margin: 0;
  padding: 0;
}

h3 {
  margin: 20px 0;
}

h4 {
  margin: 15px 0;
}

.page-box {
  padding-top: 30px;

}

.main-head {
  display: flex;
  justify-content: space-between;
  align-items: start;
  height: 40px;
}

.drawer-box {
  .drawer-head {
    height: 60px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .drawer-line {
    height: 1px;
    width: 100%;
    background-color: #ebebeb;
  }

  .drawer-title {
    font-weight: bolder;
  }

  .drawer-content {
    height: calc(100% - 122px);
    overflow: auto;
  }

  .drawer-bottom {
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .el-button {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}


// el 表格 头部背景色
body .el-table th.el-table__cell {
  //background-color: #efefef;
}

@tailwind base;
@tailwind components;
@tailwind utilities;

/* 全局标题字体规范 */
h3 {
  font-size: 18px;
  margin: 16px 0 12px;
  font-weight: bold;
  color: #303133;
}

h4 {
  font-size: 14px;
  margin: 12px 0 8px;
  font-weight: bold;
  color: #303133;
}

/* 页面通用标题类 */
.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.form-label {
  font-size: 14px;
  color: #606266;
}

.assist-text {
  font-size: 12px;
  color: #909399;
}

.h-container {
  height: calc(100vh - 128px);
}

.h-16-left {
  height: calc(100% - 64px);
}

.font-guard {
  font-weight: bold;
  font-size: 18px;
  font-family: "Microsoft YaHei", serif;
}

.font-guard-title {
  font-weight: bold;
  font-size: 20px;
  font-family: "Microsoft YaHei", serif;
}

</style>
